import getFileNameWithoutExtension from './getFileNameWithoutExtension';

/**
 * The function replaces an image extension with an extension that is supported
 * @param {string} file
 * @param {string} extensionSupported
 * @returns {string}
 */
export default function (file, extensionSupported) {
    return `${getFileNameWithoutExtension(file)}.${extensionSupported}`;
}
